// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-x-\\[10px\\] {
  left: 10px;
  right: 10px;
}
.inset-y-\\[13px\\] {
  top: 13px;
  bottom: 13px;
}
.-top-\\[10px\\] {
  top: -10px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-\\[10px\\] {
  bottom: 10px;
}
.bottom-\\[20px\\] {
  bottom: 20px;
}
.bottom-\\[2px\\] {
  bottom: 2px;
}
.bottom-\\[30px\\] {
  bottom: 30px;
}
.bottom-\\[37px\\] {
  bottom: 37px;
}
.bottom-\\[50px\\] {
  bottom: 50px;
}
.bottom-auto {
  bottom: auto;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-\\[-100\\%\\] {
  left: -100%;
}
.left-\\[-1px\\] {
  left: -1px;
}
.left-\\[-20px\\] {
  left: -20px;
}
.left-\\[-23px\\] {
  left: -23px;
}
.left-\\[-6px\\] {
  left: -6px;
}
.left-\\[-90px\\] {
  left: -90px;
}
.left-\\[0\\%\\] {
  left: 0%;
}
.left-\\[0\\] {
  left: 0;
}
.left-\\[0px\\] {
  left: 0px;
}
.left-\\[10px\\] {
  left: 10px;
}
.left-\\[20px\\] {
  left: 20px;
}
.left-\\[30px\\] {
  left: 30px;
}
.left-\\[5px\\] {
  left: 5px;
}
.right-0 {
  right: 0px;
}
.right-\\[-23px\\] {
  right: -23px;
}
.right-\\[-36px\\] {
  right: -36px;
}
.right-\\[0px\\] {
  right: 0px;
}
.right-\\[10px\\] {
  right: 10px;
}
.right-\\[15px\\] {
  right: 15px;
}
.right-\\[20px\\] {
  right: 20px;
}
.right-\\[2px\\] {
  right: 2px;
}
.right-\\[30px\\] {
  right: 30px;
}
.right-\\[50px\\] {
  right: 50px;
}
.right-\\[5px\\] {
  right: 5px;
}
.right-auto {
  right: auto;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-\\[-20px\\] {
  top: -20px;
}
.top-\\[-25px\\] {
  top: -25px;
}
.top-\\[-53px\\] {
  top: -53px;
}
.top-\\[-5px\\] {
  top: -5px;
}
.top-\\[0\\] {
  top: 0;
}
.top-\\[10px\\] {
  top: 10px;
}
.top-\\[12px\\] {
  top: 12px;
}
.top-\\[13px\\] {
  top: 13px;
}
.top-\\[15px\\] {
  top: 15px;
}
.top-\\[16px\\] {
  top: 16px;
}
.top-\\[17px\\] {
  top: 17px;
}
.top-\\[1px\\] {
  top: 1px;
}
.top-\\[20px\\] {
  top: 20px;
}
.top-\\[21px\\] {
  top: 21px;
}
.top-\\[30px\\] {
  top: 30px;
}
.top-\\[31px\\] {
  top: 31px;
}
.top-\\[3px\\] {
  top: 3px;
}
.top-\\[40px\\] {
  top: 40px;
}
.top-\\[4px\\] {
  top: 4px;
}
.top-\\[50px\\] {
  top: 50px;
}
.top-\\[55px\\] {
  top: 55px;
}
.top-\\[5px\\] {
  top: 5px;
}
.top-\\[60px\\] {
  top: 60px;
}
.top-\\[68\\%\\] {
  top: 68%;
}
.top-\\[70\\%\\] {
  top: 70%;
}
.top-\\[70px\\] {
  top: 70px;
}
.-z-10 {
  z-index: -10;
}
.z-10 {
  z-index: 10;
}
.z-\\[-1\\] {
  z-index: -1;
}
.z-\\[10\\] {
  z-index: 10;
}
.z-\\[11\\] {
  z-index: 11;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[20\\] {
  z-index: 20;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[30\\] {
  z-index: 30;
}
.z-\\[3\\] {
  z-index: 3;
}
.z-\\[9999999\\] {
  z-index: 9999999;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.z-\\[9\\] {
  z-index: 9;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-\\[10px\\] {
  margin-left: 10px;
  margin-right: 10px;
}
.mx-\\[15px\\] {
  margin-left: 15px;
  margin-right: 15px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-\\[20px\\] {
  margin-top: 20px;
  margin-bottom: 20px;
}
.my-\\[30px\\] {
  margin-top: 30px;
  margin-bottom: 30px;
}
.my-\\[50px\\] {
  margin-top: 50px;
  margin-bottom: 50px;
}
.my-\\[5px\\] {
  margin-top: 5px;
  margin-bottom: 5px;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!mt-\\[20px\\] {
  margin-top: 20px !important;
}
.-mb-px {
  margin-bottom: -1px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-\\[-25px\\] {
  margin-bottom: -25px;
}
.mb-\\[0px\\] {
  margin-bottom: 0px;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[12px\\] {
  margin-bottom: 12px;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[24px\\] {
  margin-bottom: 24px;
}
.mb-\\[25px\\] {
  margin-bottom: 25px;
}
.mb-\\[2px\\] {
  margin-bottom: 2px;
}
.mb-\\[30px\\] {
  margin-bottom: 30px;
}
.mb-\\[3px\\] {
  margin-bottom: 3px;
}
.mb-\\[40px\\] {
  margin-bottom: 40px;
}
.mb-\\[50px\\] {
  margin-bottom: 50px;
}
.mb-\\[5px\\] {
  margin-bottom: 5px;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.ml-\\[-10px\\] {
  margin-left: -10px;
}
.ml-\\[-5px\\] {
  margin-left: -5px;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-\\[30px\\] {
  margin-left: 30px;
}
.ml-\\[3px\\] {
  margin-left: 3px;
}
.ml-\\[5px\\] {
  margin-left: 5px;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-\\[-20px\\] {
  margin-right: -20px;
}
.mr-\\[-50\\%\\] {
  margin-right: -50%;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[20px\\] {
  margin-right: 20px;
}
.mr-\\[5px\\] {
  margin-right: 5px;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-\\[-20px\\] {
  margin-top: -20px;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[15px\\] {
  margin-top: 15px;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.mt-\\[40px\\] {
  margin-top: 40px;
}
.mt-\\[50px\\] {
  margin-top: 50px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[80px\\] {
  margin-top: 80px;
}
.mt-\\[8px\\] {
  margin-top: 8px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.\\!inline-flex {
  display: inline-flex !important;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.\\!h-\\[100px\\] {
  height: 100px !important;
}
.\\!h-\\[150px\\] {
  height: 150px !important;
}
.\\!h-\\[200px\\] {
  height: 200px !important;
}
.\\!h-\\[35px\\] {
  height: 35px !important;
}
.\\!h-\\[50px\\] {
  height: 50px !important;
}
.h-0 {
  height: 0px;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[\\.5em\\] {
  height: .5em;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[13px\\] {
  height: 13px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[17px\\] {
  height: 17px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[4px\\] {
  height: 4px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[50vh\\] {
  height: 50vh;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[85vh\\] {
  height: 85vh;
}
.h-\\[8px\\] {
  height: 8px;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-\\[9px\\] {
  height: 9px;
}
.h-\\[calc\\(100vh_-_157px\\)\\] {
  height: calc(100vh - 157px);
}
.h-\\[calc\\(100vh_-_70px\\)\\] {
  height: calc(100vh - 70px);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-\\[150px\\] {
  max-height: 150px;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[230px\\] {
  max-height: 230px;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[30vh\\] {
  max-height: 30vh;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.\\!w-\\[100px\\] {
  width: 100px !important;
}
.\\!w-\\[150px\\] {
  width: 150px !important;
}
.\\!w-\\[200px\\] {
  width: 200px !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-11 {
  width: 2.75rem;
}
.w-40 {
  width: 10rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[\\.25em\\] {
  width: .25em;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[13px\\] {
  width: 13px;
}
.w-\\[147px\\] {
  width: 147px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[185px\\] {
  width: 185px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[33px\\] {
  width: 33px;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[35px\\] {
  width: 35px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[45px\\] {
  width: 45px;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[4px\\] {
  width: 4px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[9px\\] {
  width: 9px;
}
.w-full {
  width: 100%;
}
.\\!min-w-\\[40px\\] {
  min-width: 40px !important;
}
.\\!min-w-\\[50px\\] {
  min-width: 50px !important;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[130px\\] {
  min-width: 130px;
}
.min-w-\\[13px\\] {
  min-width: 13px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[17px\\] {
  min-width: 17px;
}
.min-w-\\[190px\\] {
  min-width: 190px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[25px\\] {
  min-width: 25px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[30px\\] {
  min-width: 30px;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.min-w-\\[8px\\] {
  min-width: 8px;
}
.min-w-\\[9px\\] {
  min-width: 9px;
}
.\\!max-w-\\[300px\\] {
  max-width: 300px !important;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[1050px\\] {
  max-width: 1050px;
}
.max-w-\\[1100px\\] {
  max-width: 1100px;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[1240px\\] {
  max-width: 1240px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[290px\\] {
  max-width: 290px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[410px\\] {
  max-width: 410px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[650px\\] {
  max-width: 650px;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-\\[70px\\] {
  max-width: 70px;
}
.max-w-\\[75\\%\\] {
  max-width: 75%;
}
.max-w-\\[750px\\] {
  max-width: 750px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[960px\\] {
  max-width: 960px;
}
.max-w-\\[990px\\] {
  max-width: 990px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-none {
  max-width: none;
}
.flex-1 {
  flex: 1 1;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-2 {
  --tw-rotate: -2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-\\[40deg\\] {
  --tw-rotate: -40deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[40deg\\] {
  --tw-rotate: 40deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-auto {
  cursor: auto;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[30px\\] {
  gap: 30px;
}
.gap-\\[4px\\] {
  gap: 4px;
}
.gap-\\[50px\\] {
  gap: 50px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-x-\\[20px\\] {
  column-gap: 20px;
}
.gap-x-\\[70px\\] {
  column-gap: 70px;
}
.gap-y-\\[10px\\] {
  row-gap: 10px;
}
.gap-y-\\[20px\\] {
  row-gap: 20px;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-break-spaces {
  white-space: break-spaces;
}
.text-wrap {
  text-wrap: wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-\\[15px\\] {
  border-radius: 15px !important;
}
.\\!rounded-\\[30px\\] {
  border-radius: 30px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[15px\\] {
  border-radius: 15px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.\\!rounded-b-none {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.\\!rounded-l-none {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.\\!rounded-t-none {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
.rounded-b-\\[20px\\] {
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
.rounded-b-\\[40px\\] {
  border-bottom-right-radius: 40px;
  border-bottom-left-radius: 40px;
}
.rounded-l-\\[20px\\] {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.rounded-r-\\[20px\\] {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-t-\\[20px\\] {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.\\!rounded-bl-\\[20px\\] {
  border-bottom-left-radius: 20px !important;
}
.rounded-ee-\\[20px\\] {
  border-end-end-radius: 20px;
}
.\\!border {
  border-width: 1px !important;
}
.\\!border-\\[2px\\] {
  border-width: 2px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-\\[3px\\] {
  border-left-width: 3px;
}
.border-r {
  border-right-width: 1px;
}
.border-none {
  border-style: none;
}
.\\!border-\\[\\#6ca0dc\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(108 160 220 / var(--tw-border-opacity)) !important;
}
.\\!border-\\[\\#FF69B4\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 105 180 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#594cda\\] {
  --tw-border-opacity: 1;
  border-color: rgb(89 76 218 / var(--tw-border-opacity));
}
.border-\\[\\#F4C2C2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(244 194 194 / var(--tw-border-opacity));
}
.border-\\[\\#aaa\\] {
  --tw-border-opacity: 1;
  border-color: rgb(170 170 170 / var(--tw-border-opacity));
}
.border-\\[\\#c4c4c4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(196 196 196 / var(--tw-border-opacity));
}
.border-\\[\\#eb427e\\] {
  --tw-border-opacity: 1;
  border-color: rgb(235 66 126 / var(--tw-border-opacity));
}
.border-\\[\\#f2f3f4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(242 243 244 / var(--tw-border-opacity));
}
.border-\\[\\#ff4081\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 64 129 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-l-\\[\\#C15817\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(193 88 23 / var(--tw-border-opacity));
}
.border-r-black {
  --tw-border-opacity: 1;
  border-right-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.\\!bg-\\[\\#594cda\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(89 76 218 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[\\#aaa\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(170 170 170 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[\\#ffd1dc\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 209 220 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.\\!bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#000\\]\\/\\[50\\%\\] {
  background-color: rgb(0 0 0 / 50%);
}
.bg-\\[\\#111827\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-\\[\\#13deb9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(19 222 185 / var(--tw-bg-opacity));
}
.bg-\\[\\#228B22\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(34 139 34 / var(--tw-bg-opacity));
}
.bg-\\[\\#555555\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(85 85 85 / var(--tw-bg-opacity));
}
.bg-\\[\\#594cda\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(89 76 218 / var(--tw-bg-opacity));
}
.bg-\\[\\#5d87ff20\\] {
  background-color: #5d87ff20;
}
.bg-\\[\\#F5FFFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 255 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#FF0000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#FF4081\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 64 129 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#aaa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(170 170 170 / var(--tw-bg-opacity));
}
.bg-\\[\\#aaaaaa8a\\] {
  background-color: #aaaaaa8a;
}
.bg-\\[\\#addfad\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(173 223 173 / var(--tw-bg-opacity));
}
.bg-\\[\\#c6eaf9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(198 234 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#dcdcdc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 220 220 / var(--tw-bg-opacity));
}
.bg-\\[\\#e50914\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 9 20 / var(--tw-bg-opacity));
}
.bg-\\[\\#e6fffa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 255 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#e8f0feaa\\] {
  background-color: #e8f0feaa;
}
.bg-\\[\\#eb427e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 66 126 / var(--tw-bg-opacity));
}
.bg-\\[\\#f1f9fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 249 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#f5f5dc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 220 / var(--tw-bg-opacity));
}
.bg-\\[\\#f5fffa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 255 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#f8f4ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 244 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#f8f8ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#f9ffe3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 255 227 / var(--tw-bg-opacity));
}
.bg-\\[\\#fdede8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 237 232 / var(--tw-bg-opacity));
}
.bg-\\[\\#fef5e5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 245 229 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffae1f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 174 31 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffe4c4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 196 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffe4e1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 225 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff0f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 240 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff0f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 245 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffffe0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 224 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}
.bg-pink-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / var(--tw-bg-opacity));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-\\[linear-gradient\\(0deg\\2c \\#fff_0\\%\\2c \\#c5eaf9_100\\%\\)\\] {
  background-image: linear-gradient(0deg,#fff 0%,#c5eaf9 100%);
}
.bg-\\[linear-gradient\\(180deg\\2c \\#fff_0\\%\\2c \\#c5eaf9_100\\%\\)\\] {
  background-image: linear-gradient(180deg,#fff 0%,#c5eaf9 100%);
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-cyan-100 {
  --tw-gradient-from: #cffafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(207 250 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-100 {
  --tw-gradient-from: #fae8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-300 {
  --tw-gradient-from: #d4d4d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(212 212 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-600 {
  --tw-gradient-from: #525252 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(82 82 82 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-300 {
  --tw-gradient-from: #f9a8d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 168 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-300 {
  --tw-gradient-from: #cbd5e1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(203 213 225 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-200 {
  --tw-gradient-from: #ddd6fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(221 214 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500 {
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-fuchsia-500 {
  --tw-gradient-to: #d946ef var(--tw-gradient-to-position);
}
.to-pink-200 {
  --tw-gradient-to: #fbcfe8 var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-sky-100 {
  --tw-gradient-to: #e0f2fe var(--tw-gradient-to-position);
}
.to-slate-100 {
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);
}
.to-slate-500 {
  --tw-gradient-to: #64748b var(--tw-gradient-to-position);
}
.to-stone-400 {
  --tw-gradient-to: #a8a29e var(--tw-gradient-to-position);
}
.to-stone-700 {
  --tw-gradient-to: #44403c var(--tw-gradient-to-position);
}
.bg-clip-text {
  background-clip: text;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[20px\\] {
  padding: 20px;
}
.p-\\[30px\\] {
  padding: 30px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.p-\\[8px\\] {
  padding: 8px;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[21px\\] {
  padding-left: 21px;
  padding-right: 21px;
}
.px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}
.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}
.px-\\[35px\\] {
  padding-left: 35px;
  padding-right: 35px;
}
.px-\\[3px\\] {
  padding-left: 3px;
  padding-right: 3px;
}
.px-\\[4px\\] {
  padding-left: 4px;
  padding-right: 4px;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[100px\\] {
  padding-top: 100px;
  padding-bottom: 100px;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[120px\\] {
  padding-top: 120px;
  padding-bottom: 120px;
}
.py-\\[14\\.5px\\] {
  padding-top: 14.5px;
  padding-bottom: 14.5px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[40px\\] {
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[50px\\] {
  padding-top: 50px;
  padding-bottom: 50px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pb-\\[15px\\] {
  padding-bottom: 15px;
}
.pb-\\[20px\\] {
  padding-bottom: 20px;
}
.pb-\\[30px\\] {
  padding-bottom: 30px;
}
.pb-\\[45px\\] {
  padding-bottom: 45px;
}
.pb-\\[50px\\] {
  padding-bottom: 50px;
}
.pb-\\[5px\\] {
  padding-bottom: 5px;
}
.pl-\\[20px\\] {
  padding-left: 20px;
}
.pl-\\[33px\\] {
  padding-left: 33px;
}
.pl-\\[50px\\] {
  padding-left: 50px;
}
.pr-\\[20px\\] {
  padding-right: 20px;
}
.pr-\\[30px\\] {
  padding-right: 30px;
}
.pr-\\[40px\\] {
  padding-right: 40px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pt-\\[12px\\] {
  padding-top: 12px;
}
.pt-\\[15px\\] {
  padding-top: 15px;
}
.pt-\\[20px\\] {
  padding-top: 20px;
}
.pt-\\[30px\\] {
  padding-top: 30px;
}
.pt-\\[35px\\] {
  padding-top: 35px;
}
.pt-\\[3px\\] {
  padding-top: 3px;
}
.pt-\\[40px\\] {
  padding-top: 40px;
}
.pt-\\[50px\\] {
  padding-top: 50px;
}
.pt-\\[70px\\] {
  padding-top: 70px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.\\!text-\\[14px\\] {
  font-size: 14px !important;
}
.text-\\[0px\\] {
  font-size: 0px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[35px\\] {
  font-size: 35px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[50px\\] {
  font-size: 50px;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.\\!font-bold {
  font-weight: 700 !important;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-\\[27px\\] {
  line-height: 27px;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#007bff\\] {
  --tw-text-opacity: 1;
  color: rgb(0 123 255 / var(--tw-text-opacity));
}
.text-\\[\\#008000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 128 0 / var(--tw-text-opacity));
}
.text-\\[\\#00f\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 255 / var(--tw-text-opacity));
}
.text-\\[\\#228B22\\] {
  --tw-text-opacity: 1;
  color: rgb(34 139 34 / var(--tw-text-opacity));
}
.text-\\[\\#594cda\\] {
  --tw-text-opacity: 1;
  color: rgb(89 76 218 / var(--tw-text-opacity));
}
.text-\\[\\#6b747b\\] {
  --tw-text-opacity: 1;
  color: rgb(107 116 123 / var(--tw-text-opacity));
}
.text-\\[\\#800080\\] {
  --tw-text-opacity: 1;
  color: rgb(128 0 128 / var(--tw-text-opacity));
}
.text-\\[\\#808080\\] {
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity));
}
.text-\\[\\#8a8a8a\\] {
  --tw-text-opacity: 1;
  color: rgb(138 138 138 / var(--tw-text-opacity));
}
.text-\\[\\#FF0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#aaa\\] {
  --tw-text-opacity: 1;
  color: rgb(170 170 170 / var(--tw-text-opacity));
}
.text-\\[\\#ccc\\] {
  --tw-text-opacity: 1;
  color: rgb(204 204 204 / var(--tw-text-opacity));
}
.text-\\[\\#e50914\\] {
  --tw-text-opacity: 1;
  color: rgb(229 9 20 / var(--tw-text-opacity));
}
.text-\\[\\#eb427e\\] {
  --tw-text-opacity: 1;
  color: rgb(235 66 126 / var(--tw-text-opacity));
}
.text-\\[\\#ef0145\\] {
  --tw-text-opacity: 1;
  color: rgb(239 1 69 / var(--tw-text-opacity));
}
.text-\\[\\#f5c71a\\] {
  --tw-text-opacity: 1;
  color: rgb(245 199 26 / var(--tw-text-opacity));
}
.text-\\[\\#fc0fc0\\] {
  --tw-text-opacity: 1;
  color: rgb(252 15 192 / var(--tw-text-opacity));
}
.text-\\[\\#fd5901\\] {
  --tw-text-opacity: 1;
  color: rgb(253 89 1 / var(--tw-text-opacity));
}
.text-\\[\\#ff0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#ff4081\\] {
  --tw-text-opacity: 1;
  color: rgb(255 64 129 / var(--tw-text-opacity));
}
.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.placeholder-black::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(0 0 0 / var(--tw-placeholder-opacity));
}
.opacity-0 {
  opacity: 0;
}
.opacity-75 {
  opacity: 0.75;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_15px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\] {
  --tw-shadow: 0px 0px 15px 0px rgba(0,0,0,0.15);
  --tw-shadow-colored: 0px 0px 15px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[1px_1px_5px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  --tw-shadow: 1px 1px 5px 0px rgba(0,0,0,0.2);
  --tw-shadow-colored: 1px 1px 5px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* background-color: #f5fffa; */
  font-size: 14px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
  color: #154354;
}
rf
h1 {
  font-size: 35px;
}
h2 {
  font-size: 30px; 
}
h3 {
  font-size: 26px;
}
h4 {
  font-size: 22px;
}
h5 {
  font-size: 20px;
}
h6 {
  font-size: 18px;
}
p a {
  color: #00f;
}
p a:hover {
  text-decoration: underline;
}

ul li {
  list-style-type: disc;
  margin-left: 20px;
}

.switch-btn-checked:checked ~ .switch-btn .switch-btn-inner {background: linear-gradient(green, limegreen);}
.switch-btn-checked:checked ~ .switch-btn .switch-btn-inner .switch-btn-disc {left: 30%;}
.switch-btn-checked:checked ~ .switch-btn .switch-btn-inner .switch-btn-disc::before {content: 'ON';color: limegreen;}

/* Scrollbar css  */
::-webkit-scrollbar {width: 4px;border-radius: 10px;}
::-webkit-scrollbar-track {background: #cbced1;}
::-webkit-scrollbar-thumb {background: #111827; border-radius: 10px;}
.scrollar-width-zero::-webkit-scrollbar {width: 0px;}
.scrollar-width::-webkit-scrollbar {width: 4px;height: 4px; border-radius: 10px;}
.scrollar-width::-webkit-scrollbar-thumb {border-radius: 10px;}

.scrollbar-h-5px::-webkit-scrollbar {height: 5px;}





/* PRE-DEFINED COLORS */


/* FOR BACKGROUND */
.bg-primary {
  background-color: #154354;
}
.bg-secondary {
  background-color: #f0f8ff;
}
.bg-tertiary {
  background-color: #f5f5f5;
}
.bg-hover:hover {
  background-color: #f5f5f5;
  color: "#000"
}
.bg-active {
  background-color: #e8f0fe;
}
.bg-success {
  background-color: #008000;
}
.bg-strawberry{
  background-color: #FF4081;
}
.bg-default {
  background-color: #fff;
}

/* FOR TEXT */
.text-primary {
  color: #154354;
}
.text-error {
  color: #ff0000;
}
.text-success {
  color: #008000;
}
.text-default{
  color: #fff;
}
.text-link{
  color: #00f;
}
.text-link:hover{
  text-decoration: underline;
}
/* FOR BORDER */
.border-primary {
  border: 1px solid #154354;
}
.border-error {
  border: 1px solid #ff0000;
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:bottom-\\[-5px\\]::before {
  content: var(--tw-content);
  bottom: -5px;
}
.before\\:right-\\[12px\\]::before {
  content: var(--tw-content);
  right: 12px;
}
.before\\:top-\\[-16px\\]::before {
  content: var(--tw-content);
  top: -16px;
}
.before\\:ml-\\[0px\\]::before {
  content: var(--tw-content);
  margin-left: 0px;
}
.before\\:h-\\[0px\\]::before {
  content: var(--tw-content);
  height: 0px;
}
.before\\:w-\\[0px\\]::before {
  content: var(--tw-content);
  width: 0px;
}
.before\\:border-\\[8px\\]::before {
  content: var(--tw-content);
  border-width: 8px;
}
.before\\:border-l-\\[7px\\]::before {
  content: var(--tw-content);
  border-left-width: 7px;
}
.before\\:border-r-\\[7px\\]::before {
  content: var(--tw-content);
  border-right-width: 7px;
}
.before\\:border-t-\\[7px\\]::before {
  content: var(--tw-content);
  border-top-width: 7px;
}
.before\\:border-solid::before {
  content: var(--tw-content);
  border-style: solid;
}
.before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}
.before\\:border-b-\\[\\#e5e7eb\\]::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.before\\:border-l-\\[transparent\\]::before {
  content: var(--tw-content);
  border-left-color: transparent;
}
.before\\:border-r-\\[transparent\\]::before {
  content: var(--tw-content);
  border-right-color: transparent;
}
.before\\:border-t-\\[\\#000\\]::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-top-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.before\\:content-\\[\\"\\"\\]::before {
  --tw-content: "";
  content: var(--tw-content);
}
.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:start-\\[2px\\]::after {
  content: var(--tw-content);
  inset-inline-start: 2px;
}
.after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}
.after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}
.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.first\\:ml-0:first-child {
  margin-left: 0px;
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:border-b:last-child {
  border-bottom-width: 1px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.hover\\:rotate-0:hover {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border:hover {
  border-width: 1px;
}
.hover\\:border-black:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.hover\\:\\!bg-\\[\\#fff\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!bg-transparent:hover {
  background-color: transparent !important;
}
.hover\\:bg-\\[\\#000\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#eb427e\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 66 126 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#f5f5f5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#f8f8ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 255 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#fff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.hover\\:bg-gradient-to-r:hover {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.hover\\:from-violet-300:hover {
  --tw-gradient-from: #c4b5fd var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(196 181 253 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-pink-300:hover {
  --tw-gradient-to: #f9a8d4 var(--tw-gradient-to-position);
}
.hover\\:\\!text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.hover\\:text-\\[\\#000\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.hover\\:text-\\[\\#594cda\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(89 76 218 / var(--tw-text-opacity));
}
.hover\\:text-\\[\\#eb427e\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(235 66 126 / var(--tw-text-opacity));
}
.hover\\:text-\\[\\#fff\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.focus\\:border-\\[\\#1E40AF\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity));
}
.focus\\:shadow-\\[0_0_2px_\\#000000\\]:focus {
  --tw-shadow: 0 0 2px #000000;
  --tw-shadow-colored: 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.group:nth-child(even) .group-even\\:rotate-2 {
  --tw-rotate: 2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:nth-child(even) .hover\\:group-even\\:rotate-0:hover {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:block {
  display: block;
}
.group:hover .group-hover\\:flex {
  display: flex;
}
.group:hover .group-hover\\:hidden {
  display: none;
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.group:hover .group-hover\\:animate-bounce {
  animation: bounce 1s infinite;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:ring-teal-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(94 234 212 / var(--tw-ring-opacity));
}
@media not all and (min-width: 1024px) {

  .max-lg\\:order-1 {
    order: 1;
  }

  .max-lg\\:order-2 {
    order: 2;
  }

  .max-lg\\:mb-\\[20px\\] {
    margin-bottom: 20px;
  }

  .max-lg\\:ml-\\[10px\\] {
    margin-left: 10px;
  }

  .max-lg\\:mt-\\[30px\\] {
    margin-top: 30px;
  }

  .max-lg\\:flex-col {
    flex-direction: column;
  }

  .max-lg\\:justify-center {
    justify-content: center;
  }

  .max-lg\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .max-lg\\:px-\\[6px\\] {
    padding-left: 6px;
    padding-right: 6px;
  }

  .max-lg\\:text-left {
    text-align: left;
  }

  .max-lg\\:text-center {
    text-align: center;
  }
}
@media not all and (min-width: 768px) {

  .max-md\\:absolute {
    position: absolute;
  }

  .max-md\\:-left-\\[100\\%\\] {
    left: -100%;
  }

  .max-md\\:left-\\[0\\%\\] {
    left: 0%;
  }

  .max-md\\:right-\\[-70px\\] {
    right: -70px;
  }

  .max-md\\:top-0 {
    top: 0px;
  }

  .max-md\\:\\!mt-\\[15px\\] {
    margin-top: 15px !important;
  }

  .max-md\\:mb-\\[10px\\] {
    margin-bottom: 10px;
  }

  .max-md\\:mb-\\[20px\\] {
    margin-bottom: 20px;
  }

  .max-md\\:mb-\\[30px\\] {
    margin-bottom: 30px;
  }

  .max-md\\:mb-\\[5px\\] {
    margin-bottom: 5px;
  }

  .max-md\\:mr-\\[10px\\] {
    margin-right: 10px;
  }

  .max-md\\:mt-\\[20px\\] {
    margin-top: 20px;
  }

  .max-md\\:hidden {
    display: none;
  }

  .max-md\\:h-\\[100vh\\] {
    height: 100vh;
  }

  .max-md\\:h-\\[32px\\] {
    height: 32px;
  }

  .max-md\\:h-\\[50px\\] {
    height: 50px;
  }

  .max-md\\:h-\\[75vh\\] {
    height: 75vh;
  }

  .max-md\\:max-h-\\[calc\\(100vh_-_36vh\\)\\] {
    max-height: calc(100vh - 36vh);
  }

  .max-md\\:w-\\[150px\\] {
    width: 150px;
  }

  .max-md\\:w-\\[32px\\] {
    width: 32px;
  }

  .max-md\\:w-\\[45px\\] {
    width: 45px;
  }

  .max-md\\:w-\\[50px\\] {
    width: 50px;
  }

  .max-md\\:w-full {
    width: 100%;
  }

  .max-md\\:max-w-\\[250px\\] {
    max-width: 250px;
  }

  .max-md\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .max-md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .max-md\\:flex-col {
    flex-direction: column;
  }

  .max-md\\:flex-wrap {
    flex-wrap: wrap;
  }

  .max-md\\:justify-between {
    justify-content: space-between;
  }

  .max-md\\:gap-\\[15px\\] {
    gap: 15px;
  }

  .max-md\\:overflow-hidden {
    overflow: hidden;
  }

  .max-md\\:overflow-y-auto {
    overflow-y: auto;
  }

  .max-md\\:bg-\\[linear-gradient\\(180deg\\2c \\#fff_0\\%\\2c \\#c5eaf9_100\\%\\)\\] {
    background-image: linear-gradient(180deg,#fff 0%,#c5eaf9 100%);
  }

  .max-md\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .max-md\\:px-\\[15px\\] {
    padding-left: 15px;
    padding-right: 15px;
  }

  .max-md\\:py-\\[100px\\] {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .max-md\\:py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .max-md\\:py-\\[20px\\] {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .max-md\\:py-\\[24px\\] {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .max-md\\:py-\\[50px\\] {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .max-md\\:py-\\[8px\\] {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .max-md\\:pb-\\[10px\\] {
    padding-bottom: 10px;
  }

  .max-md\\:pb-\\[20px\\] {
    padding-bottom: 20px;
  }

  .max-md\\:pb-\\[50px\\] {
    padding-bottom: 50px;
  }

  .max-md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .max-md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .max-md\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .max-md\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .max-md\\:text-\\[35px\\] {
    font-size: 35px;
  }

  .max-md\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .max-md\\:leading-\\[27px\\] {
    line-height: 27px;
  }

  .max-md\\:leading-\\[28px\\] {
    line-height: 28px;
  }

  .max-md\\:leading-\\[34px\\] {
    line-height: 34px;
  }

  .max-md\\:leading-\\[35px\\] {
    line-height: 35px;
  }

  .max-md\\:leading-\\[54px\\] {
    line-height: 54px;
  }

  .max-md\\:shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .max-md\\:duration-700 {
    transition-duration: 700ms;
  }
}
@media not all and (min-width: 640px) {

  .max-sm\\:hidden {
    display: none;
  }

  .max-sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (min-width: 640px) {

  .sm\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }
}
@media (min-width: 768px) {

  .md\\:right-0 {
    right: 0px;
  }

  .md\\:mb-\\[10px\\] {
    margin-bottom: 10px;
  }

  .md\\:mb-\\[20px\\] {
    margin-bottom: 20px;
  }

  .md\\:mb-\\[30px\\] {
    margin-bottom: 30px;
  }

  .md\\:mb-\\[40px\\] {
    margin-bottom: 40px;
  }

  .md\\:ml-\\[3px\\] {
    margin-left: 3px;
  }

  .md\\:mr-\\[20px\\] {
    margin-right: 20px;
  }

  .md\\:mt-\\[30px\\] {
    margin-top: 30px;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[100vh\\] {
    height: 100vh;
  }

  .md\\:h-\\[40px\\] {
    height: 40px;
  }

  .md\\:h-\\[70px\\] {
    height: 70px;
  }

  .md\\:h-\\[calc\\(100vh_-_163px\\)\\] {
    height: calc(100vh - 163px);
  }

  .md\\:max-h-\\[calc\\(100vh_-_250px\\)\\] {
    max-height: calc(100vh - 250px);
  }

  .md\\:w-\\[180px\\] {
    width: 180px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[40px\\] {
    width: 40px;
  }

  .md\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .md\\:w-\\[70px\\] {
    width: 70px;
  }

  .md\\:max-w-\\[300px\\] {
    max-width: 300px;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:gap-\\[10px\\] {
    gap: 10px;
  }

  .md\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .md\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .md\\:gap-\\[40px\\] {
    gap: 40px;
  }

  .md\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .md\\:px-\\[15px\\] {
    padding-left: 15px;
    padding-right: 15px;
  }

  .md\\:px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
  }

  .md\\:px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px;
  }

  .md\\:px-\\[40px\\] {
    padding-left: 40px;
    padding-right: 40px;
  }

  .md\\:py-\\[12px\\] {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .md\\:py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .md\\:py-\\[90px\\] {
    padding-top: 90px;
    padding-bottom: 90px;
  }

  .md\\:pb-\\[20px\\] {
    padding-bottom: 20px;
  }

  .md\\:pb-\\[50px\\] {
    padding-bottom: 50px;
  }

  .md\\:pb-\\[90px\\] {
    padding-bottom: 90px;
  }

  .md\\:pr-\\[40px\\] {
    padding-right: 40px;
  }

  .md\\:pt-\\[10px\\] {
    padding-top: 10px;
  }

  .md\\:pt-\\[150px\\] {
    padding-top: 150px;
  }

  .md\\:pt-\\[90px\\] {
    padding-top: 90px;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .md\\:text-\\[34px\\] {
    font-size: 34px;
  }

  .md\\:text-\\[50px\\] {
    font-size: 50px;
  }

  .md\\:text-\\[54px\\] {
    font-size: 54px;
  }

  .md\\:leading-\\[27px\\] {
    line-height: 27px;
  }

  .md\\:leading-\\[30px\\] {
    line-height: 30px;
  }

  .md\\:leading-\\[40px\\] {
    line-height: 40px;
  }

  .md\\:leading-\\[50px\\] {
    line-height: 50px;
  }

  .md\\:leading-\\[64px\\] {
    line-height: 64px;
  }
}
@media (min-width: 1024px) {

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-\\[30px\\] {
    margin-bottom: 30px;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:ml-\\[250px\\] {
    margin-left: 250px;
  }

  .lg\\:ml-auto {
    margin-left: auto;
  }

  .lg\\:mr-\\[30px\\] {
    margin-right: 30px;
  }

  .lg\\:mt-\\[30px\\] {
    margin-top: 30px;
  }

  .lg\\:mt-\\[40px\\] {
    margin-top: 40px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/4 {
    width: 25%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .lg\\:w-\\[700px\\] {
    width: 700px;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:max-w-3xl {
    max-width: 48rem;
  }

  .lg\\:max-w-6xl {
    max-width: 72rem;
  }

  .lg\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .lg\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .lg\\:gap-x-12 {
    column-gap: 3rem;
  }

  .lg\\:gap-x-8 {
    column-gap: 2rem;
  }

  .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .lg\\:p-\\[30px\\] {
    padding: 30px;
  }

  .lg\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .lg\\:px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px;
  }

  .lg\\:px-\\[5px\\] {
    padding-left: 5px;
    padding-right: 5px;
  }

  .lg\\:pt-\\[50px\\] {
    padding-top: 50px;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-right {
    text-align: right;
  }
}
@media (min-width: 1280px) {

  .xl\\:ml-14 {
    margin-left: 3.5rem;
  }

  .xl\\:mr-12 {
    margin-right: 3rem;
  }

  .xl\\:mr-14 {
    margin-right: 3.5rem;
  }

  .xl\\:mt-40 {
    margin-top: 10rem;
  }

  .xl\\:mt-\\[15px\\] {
    margin-top: 15px;
  }

  .xl\\:mt-\\[60px\\] {
    margin-top: 60px;
  }

  .xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .xl\\:w-2\\/3 {
    width: 66.666667%;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:gap-10 {
    gap: 2.5rem;
  }

  .xl\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .xl\\:gap-\\[30px\\] {
    gap: 30px;
  }
}
@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
.peer:checked ~ .rtl\\:peer-checked\\:after\\:-translate-x-full:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (prefers-color-scheme: dark) {

  .dark\\:border-gray-600 {
    --tw-border-opacity: 1;
    border-color: rgb(75 85 99 / var(--tw-border-opacity));
  }

  .dark\\:border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity));
  }

  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }

  .dark\\:text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }

  .peer:focus ~ .dark\\:peer-focus\\:ring-teal-800 {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(17 94 89 / var(--tw-ring-opacity));
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,6DAA6D,6CAA6C,CAAC;AAC3G,8EAA8E,SAAS,CAAC;AACxF,sFAAsF,aAAa,CAAC,gBAAgB,CAAC;;AAErH,mBAAmB;AACnB,qBAAqB,UAAU,CAAC,mBAAmB,CAAC;AACpD,2BAA2B,mBAAmB,CAAC;AAC/C,2BAA2B,mBAAmB,EAAE,mBAAmB,CAAC;AACpE,yCAAyC,UAAU,CAAC;AACpD,oCAAoC,UAAU,CAAC,WAAW,EAAE,mBAAmB,CAAC;AAChF,0CAA0C,mBAAmB,CAAC;;AAE9D,qCAAqC,WAAW,CAAC;;;;;;AAMjD,uBAAuB;;;AAGvB,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA,eAAe;AACf;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AAhIA;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID,sBAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID,sBAgIC;EAhID;AAgIC;AAhID;EAAA,gBAgIC;EAhID;AAgIC;AAhID;EAAA,gBAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID,sBAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID,kBAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID,wBAgIC;EAhID,wDAgIC;EAhID;AAgIC;AAhID;EAAA,gBAgIC;EAhID;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA,iBAgIC;EAhID;AAgIC;AAhID;EAAA,kBAgIC;EAhID,kBAgIC;EAhID;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA,sBAgIC;EAhID;AAgIC;AAhID;EAAA,6BAgIC;EAhID;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA,kBAgIC;EAhID;AAgIC;AAhID;EAAA,kBAgIC;EAhID;AAgIC;AAhID;EAAA,kBAgIC;EAhID;AAgIC;AAhID;EAAA,kBAgIC;EAhID;AAgIC;AAhID;EAAA,kBAgIC;EAhID;AAgIC;AAhID;EAAA,kBAgIC;EAhID;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA,4DAgIC;EAhID,qEAgIC;EAhID;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA,+BAgIC;EAhID;AAgIC;AAhID;EAAA,oBAgIC;EAhID;AAgIC;AAhID;EAAA,oBAgIC;EAhID;AAgIC;AAhID;EAAA,oBAgIC;EAhID;AAgIC;AAhID;EAAA,oBAgIC;EAhID;AAgIC;AAhID;EAAA,oBAgIC;EAhID;AAgIC;AAhID;EAAA,oBAgIC;EAhID;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA,sBAgIC;EAhID;AAgIC;AAhID;EAAA,4BAgIC;EAhID,mDAgIC;EAhID;AAgIC;AAhID;EAAA,8BAgIC;EAhID;AAgIC;AAhID;EAAA,iBAgIC;EAhID;AAgIC;AAhID;EAAA,iBAgIC;EAhID;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA;AAgIC;AAhID;;EAAA;IAAA,2BAgIC;IAhID;EAgIC;;EAhID;IAAA,eAgIC;IAhID;EAgIC;AAAA;AAhID;EAAA;AAgIC;AAhID;EAAA;AAgIC;AAhID;EAAA,kBAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID,sBAgIC;EAhID;AAgIC;AAhID;EAAA,0BAgIC;EAhID,sBAgIC;EAhID;AAgIC;AAhID;EAAA,oBAgIC;EAhID;AAgIC;AAhID;;EAAA;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;AAAA;AAhID;;EAAA;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA,gBAgIC;IAhID;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA,6EAgIC;IAhID,iGAgIC;IAhID;EAgIC;;EAhID;IAAA;EAgIC;AAAA;AAhID;;EAAA;IAAA;EAgIC;;EAhID;IAAA;EAgIC;AAAA;AAhID;;EAAA;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;AAAA;AAhID;;EAAA;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;AAAA;AAhID;;EAAA;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA,uBAgIC;IAhID,2DAgIC;IAhID;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,iBAgIC;IAhID;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;AAAA;AAhID;;EAAA;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;;EAhID;IAAA;EAgIC;AAAA;AAhID;;EAAA;IAAA;EAgIC;AAAA;AAhID;EAAA,0BAgIC;EAhID,uBAgIC;EAhID;AAgIC;AAhID;;EAAA;IAAA,sBAgIC;IAhID;EAgIC;;EAhID;IAAA,sBAgIC;IAhID;EAgIC;;EAhID;IAAA,kBAgIC;IAhID;EAgIC;;EAhID;IAAA,oBAgIC;IAhID;EAgIC;;EAhID;IAAA,oBAgIC;IAhID;EAgIC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* background-color: #f5fffa; */\n  font-size: 14px;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: bold;\n  color: #154354;\n}\nrf\nh1 {\n  font-size: 35px;\n}\nh2 {\n  font-size: 30px; \n}\nh3 {\n  font-size: 26px;\n}\nh4 {\n  font-size: 22px;\n}\nh5 {\n  font-size: 20px;\n}\nh6 {\n  font-size: 18px;\n}\np a {\n  color: #00f;\n}\np a:hover {\n  text-decoration: underline;\n}\n\nul li {\n  list-style-type: disc;\n  margin-left: 20px;\n}\n\n.switch-btn-checked:checked ~ .switch-btn .switch-btn-inner {background: linear-gradient(green, limegreen);}\n.switch-btn-checked:checked ~ .switch-btn .switch-btn-inner .switch-btn-disc {left: 30%;}\n.switch-btn-checked:checked ~ .switch-btn .switch-btn-inner .switch-btn-disc::before {content: 'ON';color: limegreen;}\n\n/* Scrollbar css  */\n::-webkit-scrollbar {width: 4px;border-radius: 10px;}\n::-webkit-scrollbar-track {background: #cbced1;}\n::-webkit-scrollbar-thumb {background: #111827; border-radius: 10px;}\n.scrollar-width-zero::-webkit-scrollbar {width: 0px;}\n.scrollar-width::-webkit-scrollbar {width: 4px;height: 4px; border-radius: 10px;}\n.scrollar-width::-webkit-scrollbar-thumb {border-radius: 10px;}\n\n.scrollbar-h-5px::-webkit-scrollbar {height: 5px;}\n\n\n\n\n\n/* PRE-DEFINED COLORS */\n\n\n/* FOR BACKGROUND */\n.bg-primary {\n  background-color: #154354;\n}\n.bg-secondary {\n  background-color: #f0f8ff;\n}\n.bg-tertiary {\n  background-color: #f5f5f5;\n}\n.bg-hover:hover {\n  background-color: #f5f5f5;\n  color: \"#000\"\n}\n.bg-active {\n  background-color: #e8f0fe;\n}\n.bg-success {\n  background-color: #008000;\n}\n.bg-strawberry{\n  background-color: #FF4081;\n}\n.bg-default {\n  background-color: #fff;\n}\n\n/* FOR TEXT */\n.text-primary {\n  color: #154354;\n}\n.text-error {\n  color: #ff0000;\n}\n.text-success {\n  color: #008000;\n}\n.text-default{\n  color: #fff;\n}\n.text-link{\n  color: #00f;\n}\n.text-link:hover{\n  text-decoration: underline;\n}\n/* FOR BORDER */\n.border-primary {\n  border: 1px solid #154354;\n}\n.border-error {\n  border: 1px solid #ff0000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
